// TSP map display utilities


export const getVisiblePaths = (currentMode, autoPath, customPath) => {
  if (currentMode === 'Compare Paths') {
    // Compare mode shows both paths, but only confirmed custom paths
    const confirmedCustomPath = customPath && customPath._isConfirmed ? customPath : [];
    return {
      auto: autoPath,
      custom: confirmedCustomPath
    };
  } else if (currentMode === 'Auto Path') {
    // Auto mode only shows auto path
    return {
      auto: autoPath
    };
  } else if (currentMode === 'Custom Path') {
    // Custom mode shows custom path (including unconfirmed for editing)
    return {
      custom: customPath
    };
  }
  // Default: no paths shown
  return {};
};

export const shouldShowAutoPath = (currentMode) => {
  return currentMode === 'Auto Path' || currentMode === 'Compare Paths';
};

export const shouldShowCustomPath = (currentMode) => {
  return currentMode === 'Custom Path' || currentMode === 'Compare Paths';
};

export const shouldShowDistanceLabels = (currentMode) => {
  return currentMode === 'Compare Paths' || currentMode === 'Custom Path' || currentMode === 'Auto Path';
};

export const hasPathsToShow = (shouldShowAutoPath, shouldShowCustomPath, autoPath, customPath) => {
  const hasAutoPaths = shouldShowAutoPath && autoPath && autoPath.length > 1;
  const hasCustomPaths = shouldShowCustomPath && customPath && customPath.length > 1;
  return { hasAutoPaths, hasCustomPaths };
};

export const getMapContainerClassName = (currentMode, setupSubmode) => {
  let className = "map-container";
  
  // Only show crosshair cursor in "Setup Points" mode's "Map Points" submode
  if (currentMode === 'Setup Points' && setupSubmode === 'Map Points') {
    className += " map-point-mode";
  }
  
  // Add pointer cursor in custom path mode
  if (currentMode === 'Custom Path') {
    className += " map-custom-mode";
  }
  
  return className;
}; 